export default {
  error: state => state.error,
  formLoading: state => state.formLoading,
  success: state => state.success,
  loading: state => state.loading,
  faq: state => state.faq,
  faqs: state => state.faqs,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/FAQs/getters.js